import Nav from '../components/Nav';
import heroimageS from "../assets/images/small/Nadine&JP-163.webp";
import heroimageL from "../assets/images/big/Nadine&JP-163.jpg";
import Hero from '../components/Hero';
import {
  Box,
} from '@mui/material';

import { Widget } from '@typeform/embed-react'

export default function RSVP() {
  return (
    <Box className="rsvp">
      <Nav />
      <Hero name="RSVP" imageS={heroimageS} imageL={heroimageL} />
      <Box sx={{ backgroundColor: "#F0E6DC"}}>
      <Widget id="vlunub3F" className="rsvp-form" />
      </Box>
    </Box>
  );
}